var _circle, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrainingimage = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 24,
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12.0508,
  cy: 12,
  r: 12,
  fill: "url(#paint0_linear_16936_137050)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.60942 4.04865C5.33466 4.14435 5.16487 4.32341 5.08151 4.60743C4.95494 5.04889 5.23279 5.53667 5.66808 5.62928C5.7823 5.65398 7.46173 5.66015 11.6479 5.65398L17.4673 5.64472L17.6185 5.56754C17.8964 5.42553 18.0477 5.17238 18.0507 4.84205C18.0538 4.48703 17.884 4.21535 17.5753 4.07334L17.4364 4.00851L11.6016 4.00234C6.10337 3.99617 5.75761 3.99925 5.60942 4.04865Z",
  fill: "url(#paint1_linear_16936_137050)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.06015 8.93256C6.06015 11.6925 6.06015 11.7419 6.12498 11.9086C6.20216 12.1154 6.38739 12.3161 6.6004 12.4211L6.75476 12.4982H16.3559L16.5102 12.4211C16.7202 12.3192 16.9085 12.1154 16.9857 11.9086C17.0505 11.7419 17.0505 11.6925 17.0505 8.93256V6.12323H6.06015V8.93256ZM15.3865 7.35501C15.4606 7.41367 15.4606 7.42293 15.4699 8.07124C15.4791 8.7782 15.4668 8.86773 15.3309 8.92947C15.226 8.97887 15.0963 8.92638 15.0469 8.82142C15.0284 8.7782 15.013 8.58679 15.013 8.38304V8.02184L14.0004 9.03444C13.4447 9.59013 12.9723 10.0439 12.9507 10.0439C12.8612 10.0439 12.7254 9.93589 12.3889 9.59939L12.0338 9.24128L11.3855 9.8865C11.0305 10.2415 10.7063 10.5472 10.6693 10.5657C10.5613 10.6212 10.4748 10.5595 10.0117 10.0933L9.59496 9.67348L8.80773 10.4576C8.37553 10.8898 7.98963 11.2572 7.9495 11.2757C7.91245 11.2973 7.8538 11.3035 7.81984 11.2942C7.74575 11.2696 7.63461 11.1337 7.63461 11.0689C7.63461 11.0411 8.05446 10.5965 8.56694 10.0841C9.37886 9.27215 9.5147 9.14866 9.59496 9.14866C9.67214 9.14866 9.75858 9.21967 10.1414 9.60248L10.5983 10.0594L11.2713 9.38637C11.8455 8.81525 11.9536 8.71646 12.0338 8.71646C12.111 8.71646 12.1944 8.78437 12.534 9.12396L12.9446 9.53456L13.8244 8.65471C14.3091 8.17003 14.7042 7.76561 14.7042 7.75326C14.7042 7.73782 14.5314 7.72856 14.3183 7.72856C13.9726 7.72856 13.9263 7.72239 13.8707 7.66682C13.8367 7.63286 13.809 7.56494 13.809 7.51246C13.809 7.45998 13.8367 7.39206 13.8707 7.3581C13.9294 7.29944 13.9726 7.29636 14.624 7.29636C15.2568 7.29636 15.3217 7.30253 15.3865 7.35501Z",
  fill: "url(#paint2_linear_16936_137050)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0922 13.1095C10.8206 13.2021 10.6353 13.3163 10.4501 13.5047C9.98395 13.9801 9.87898 14.721 10.1908 15.3045C10.2371 15.3909 10.3637 15.5545 10.4748 15.6657C11.083 16.28 12.0277 16.28 12.6358 15.6657C12.9538 15.3446 13.0989 15.005 13.0989 14.5821C13.0989 13.8875 12.642 13.2886 11.9597 13.0879C11.7128 13.0169 11.3392 13.0262 11.0922 13.1095Z",
  fill: "url(#paint3_linear_16936_137050)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0056 16.669C9.50544 16.7894 9.07941 17.1877 8.92813 17.6724C8.87874 17.8329 8.86948 17.9595 8.86948 18.5337C8.86948 19.1511 8.87565 19.2129 8.92813 19.2777L8.98679 19.3518H14.1239L14.1825 19.2777C14.235 19.2129 14.2412 19.1511 14.2412 18.5337C14.2412 17.9595 14.2319 17.8329 14.1825 17.6724C14.0281 17.1784 13.6052 16.7863 13.0927 16.6659C12.818 16.6011 10.2711 16.6042 10.0056 16.669Z",
  fill: "url(#paint4_linear_16936_137050)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_16936_137050",
  x1: 12.0508,
  y1: 0,
  x2: 12.0508,
  y2: 24,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF1FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFBEF9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_16936_137050",
  x1: 11.7712,
  y1: 4,
  x2: 11.5551,
  y2: 19.3523,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FD7FFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#AA3BFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_16936_137050",
  x1: 11.7712,
  y1: 4,
  x2: 11.5551,
  y2: 19.3523,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FD7FFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#AA3BFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_16936_137050",
  x1: 11.7712,
  y1: 4,
  x2: 11.5551,
  y2: 19.3523,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FD7FFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#AA3BFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_16936_137050",
  x1: 11.7712,
  y1: 4,
  x2: 11.5551,
  y2: 19.3523,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FD7FFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#AA3BFF"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrainingimage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/trainingimage.eb01ea2b8464f9a84463d79c5a6733ea.svg";